module.exports = __webpack_public_path__ + "static/media/profile_picture_2.d4699a1b.jpg";